// Copyright 2019 Cognite AS

/** @hidden */
export const API_VERSION: string = 'v1';
/** @hidden */
export const BASE_URL: string = 'https://api.cognitedata.com';

/** @hidden */
export const AUTHORIZATION_HEADER = 'Authorization';
/** @hidden */
export const API_KEY_HEADER = 'api-key';
/** @hidden */
export const X_CDF_APP_HEADER = 'x-cdp-app';
/** @hidden */
export const X_CDF_SDK_HEADER = 'x-cdp-sdk';
/** @hidden */
export const X_REQUEST_ID = 'X-Request-Id';
